import React from 'react'
import { Box } from 'ui-components'
import moment from 'moment'

import { TaskCellProps } from './task-cell'

const TaskAgeCell = ({ task }: TaskCellProps) => {
  const timeDiff = React.useMemo(() => {
    return task.creationTime?.getTime()
      ? new Date().getTime() - task.creationTime?.getTime()
      : undefined
  }, [task.creationTime])

  const taskAge = React.useMemo(() => {
    if (!task.creationTime) return undefined

    const taskHours = moment.duration(timeDiff).hours()
    const taskDays = moment.duration(timeDiff).days()
    const taskMonths = moment.duration(timeDiff).months()

    const formatTaskAge = (duration: number, unit: string) => {
      return duration > 1 ? duration + ' ' + unit + 's' : duration + ' ' + unit
    }

    return taskMonths
      ? formatTaskAge(taskMonths, 'month')
      : taskDays
      ? formatTaskAge(taskDays, 'day')
      : taskHours
      ? formatTaskAge(taskHours, 'hour')
      : undefined
  }, [task.creationTime, timeDiff])

  return (
    <Box>
      {taskAge}
      {/*intent needs to be modified later as per sla defined for each type of task */}
    </Box>
  )
}

export default TaskAgeCell
